<template>
    <div class="pt-2">
        <div class="col-sm-12">
            <Transition name="fade">
                <mvr-inspection-templates-list v-if="!editMode" :defaultTemplates="inspectionTemplates" @add="editMode = true" @selected="onEditInspectionTemplate" />
            </Transition>
            <base-modal v-if="editMode" size="xl" :hide-header="true" :hide-footer="true" @close="clearEditState">
                <mvr-inspection-template-editor :editInspectionTemplate="inspectionTemplate" @closeAndUpdate="updateTemplate" @close="clearEditState" />
            </base-modal>
            <div v-if="loading" id="loader" class="spinner" />
        </div>
    </div>
</template>

<script>
import { restApi } from '../../mixins/RestApiMixin'
import MvrInspectionTemplatesList from '@/components/inspections/mvrInspections/MvrInspectionTemplatesList'
import MvrInspectionTemplateEditor from '@/components/inspections/mvrInspections/MvrInspectionTemplateEditor'
import BaseModal from "@/components/BaseModal";

export default {
    name: 'MvrInspectionTemplatesView',
    components: {
        BaseModal,
        MvrInspectionTemplatesList,
        MvrInspectionTemplateEditor
    },
    mixins: [restApi],
    data: function () {
        return {
            inspectionTemplates: [],
            inspectionTemplate: null,
            editMode: false,
            loading: true
        }
    },
    mounted: function () {
        this.fetchTemplates()
    },
    methods: {
        fetchTemplates() {
            this.inspectionTemplates = []
            this.loading = true
            this.restFetch(this.mvrInspectionTemplateseUrl, (response) => {
                this.inspectionTemplates = response.data
                this.loading = false
            })
        },
        updateTemplate() {
            this.clearEditState()
            this.fetchTemplates()
        },
        onEditInspectionTemplate(template) {
            this.editMode = true
            this.inspectionTemplate = JSON.parse(JSON.stringify(template))
        },
        clearEditState() {
            this.editMode = false
            this.inspectionTemplate = null
        }
    }
}
</script>
